exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-sortable-hoc-helper.sorting {\n  background: white;\n  border-bottom: 2px solid #509ee3;\n}\n\n.react-sortable-hoc-helper.sorting > svg {\n  color: #509ee3;\n  opacity: 0.5;\n}\n", ""]);

// exports
